// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__xwRkS","log":"ModalInventoryLogs_log__2qftN","date":"ModalInventoryLogs_date__2LSh8","userName":"ModalInventoryLogs_userName__1D_FJ"};